import React from "react";
import { Row, Badge, StaticField, Button } from "@intech/web-ui";
import { GreenColumn, CenteredColumn, LeftColumn, ResultadoRow } from "./styles";
import { FuncionarioEntidade, LoginEntidade } from "@entidades";
import { UsuarioService, FuncionarioService } from "@services";
import { Session } from "@intech/react-service";
import { useHistory } from "react-router-dom";
import { DMN_ORIGEM_SISTEMA } from "@domains";

interface IProps {
  Funcionario: FuncionarioEntidade
}

export const ResultadoItem: React.FC<IProps> = ({
  Funcionario
}) => {
  const history = useHistory();

  const Pensionista = Funcionario.PENSIONISTA === "S";

  async function Selecionar(cpf: string, inscricao: string) {
    try {
      let loginInfo = new LoginEntidade();
      loginInfo.Cpf = cpf;
      loginInfo.Inscricao = inscricao;
      loginInfo.Origem = DMN_ORIGEM_SISTEMA.PORTAL;
      const login = await UsuarioService.SelecionarParticipante(loginInfo);

      await Session.setToken(login.AccessToken, true);

      var dados = await FuncionarioService.Buscar();

      localStorage.setItem(
        "fundacao",
        dados.Funcionario.CD_FUNDACAO
      );
      localStorage.setItem(
        "empresa",
        dados.Funcionario.CD_EMPRESA
      );
      localStorage.setItem(
        "pensionista",
        login.Pensionista.toString()
      );

      history.push("/");
    }
    catch (e) {
      const error = e.response ? e.response.data : e;
      console.log(error);
      window.alert(error);
    }
  };

  return (
    <ResultadoRow>
      <CenteredColumn>
        {Pensionista && (
          <GreenColumn>
            PENSIONISTA
          </GreenColumn>
        )}
      </CenteredColumn>
      <LeftColumn>
        {Funcionario.NOME_ENTID}
      </LeftColumn>
      <CenteredColumn>
        {Funcionario.NUM_MATRICULA}
      </CenteredColumn>
      <CenteredColumn>
        {Funcionario.CPF_CGC}
      </CenteredColumn>
      <CenteredColumn>
        {Funcionario.CD_EMPRESA}
      </CenteredColumn>
      <CenteredColumn>
        {Funcionario.CD_PLANO}
      </CenteredColumn>
      <CenteredColumn>
        <Button
          type={"primary"}
          onClick={async () => await Selecionar(Funcionario.CPF_CGC, Funcionario.NUM_INSCRICAO)}
          title={"Selecionar"}
          loadingText={"Selecionando..."}
          usesLoading
        />

      </CenteredColumn>
    </ResultadoRow>
  );
}
